// extracted by mini-css-extract-plugin
export default {"item":"TaskItem_item__1ZOJe","completed":"TaskItem_completed__fvIcV","dark":"TaskItem_dark__V-hHX"};